module.exports = __webpack_public_path__ + "/images/ico-fondos-hucha-color.58a457b.svg";